import { render, staticRenderFns } from "./feeRelationSale.vue?vue&type=template&id=a0fbd28a&scoped=true&"
import script from "./feeRelationSale.vue?vue&type=script&lang=js&"
export * from "./feeRelationSale.vue?vue&type=script&lang=js&"
import style0 from "./feeRelationSale.vue?vue&type=style&index=0&id=a0fbd28a&lang=scss&scoped=true&"
import style1 from "./feeRelationSale.vue?vue&type=style&index=1&id=a0fbd28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fbd28a",
  null
  
)

export default component.exports